import { useState } from "react";

interface TodoFormProps {
  onAddTodo: (body: string) => void;
}

const TodoForm = ({ onAddTodo }: TodoFormProps) => {
  const [body, setBody] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (body.trim()) {
      onAddTodo(body.trim());
      setBody("");
    }
  };

  return (
    <form onSubmit={handleSubmit} className='max-w-4xl mx-auto p-6 mb-8'>
      <div className='flex items-center space-x-4'>
        <input
          type='text'
          value={body}
          onChange={(e) => setBody(e.target.value)}
          placeholder='Wat u need todo?'
          className='flex-1 px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500'
        />
        <button
          type='submit'
          className='px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700'>
          Add
        </button>
      </div>
    </form>
  );
};

export default TodoForm;
